import type { FC } from 'react'
import { ReactNode } from 'react'
import { Box } from '@mui/material'

type Props = {
  tableFooterBar?: ReactNode
}

export const DataGridFooterBar: FC<Props> = ({ tableFooterBar }) => (
  <Box data-test="datagrid-footer">{tableFooterBar}</Box>
)

export type DataGridFooterBarProps = Props
